import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridModule, NSSelectModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { PermitShipmentActionsComponent } from '@ruby/modules/unit-train/submodules/permit/components/permit-shipment-actions/permit-shipment-actions.component';
import { PermitSingleComponent } from '@ruby/modules/unit-train/submodules/permit/components/permit-single/permit-single.component';
import { PermitComponent } from '@ruby/modules/unit-train/submodules/permit/components/permit/permit.component';
import { ShipmentLinkActionsComponent } from '@ruby/modules/unit-train/submodules/permit/components/shipment-link-actions/shipment-link-actions.component';
import { EmptyPermitContainer } from '@ruby/modules/unit-train/submodules/permit/containers/empty-permit/empty-permit.container';
import { PermitSingleContainer } from '@ruby/modules/unit-train/submodules/permit/containers/permit-single/permit-single.container';
import { PermitContainer } from '@ruby/modules/unit-train/submodules/permit/containers/permit/permit.container';
import { PermitRoutingModule } from '@ruby/modules/unit-train/submodules/permit/permit-routing.module';
import { UTEmptyPermitModule } from '@ruby/shared/components/ut-empty-permit/ut-empty-permit.module';
import { EventCodesDialogModule } from '@ruby/shared/dialogs/event-codes/event-codes.dialog.module';
import { AddShipmentsModule } from '@ruby/shared/dialogs/unit-train/add-shipments-dialog/add-shipments.module';
import { CarsWaybillModule } from '@ruby/shared/dialogs/unit-train/cars-waybilled/cars-waybill.module';
import { DisputeDetentionDialogModule } from '@ruby/shared/dialogs/unit-train/dispute-detention/dispute-detention.dialog.module';
import { PermitCommentsModule } from '@ruby/shared/dialogs/unit-train/permit-comments/permit-comments.module';
import { PermitSearchDialogModule } from '@ruby/shared/dialogs/unit-train/permit-search-dialog/permit-search.module';
import { TrainConsistModule } from '@ruby/shared/dialogs/unit-train/train-consist/train-consist.module';
import { TrainRouteModule } from '@ruby/shared/dialogs/unit-train/train-route/train-route.module';
import { ViewPermitDialogModule } from '@ruby/shared/dialogs/unit-train/view-permit/view-permit.dialog.module';
import { WaybillDetailsTableDialogModule } from '@ruby/shared/dialogs/unit-train/waybill-details-table/waybill-details-table.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [
    PermitSingleContainer,
    PermitSingleComponent,
    PermitContainer,
    PermitComponent,
    PermitShipmentActionsComponent,
    ShipmentLinkActionsComponent,
    EmptyPermitContainer
  ],
  imports: [
    AddShipmentsModule,
    CommonModule,
    DirectivesModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatTabsModule,
    MatTooltipModule,
    MatSelectModule,
    MatRadioModule,
    MatToolbarModule,
    MatCheckboxModule,
    NSSelectModule,
    NSGridModule,
    NSSkeletonModule,
    PermitRoutingModule,
    PermitCommentsModule,
    PermitSearchDialogModule,
    ReactiveFormsModule,
    TrainConsistModule,
    EventCodesDialogModule,
    CarsWaybillModule,
    WaybillDetailsTableDialogModule,
    ViewPermitDialogModule,
    TrainRouteModule,
    DisputeDetentionDialogModule,
    UTEmptyPermitModule,
    PipesModule
  ],
  exports: [PermitContainer]
})
export class PermitModule {}
